// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"d986c4e2","215":"d97a2b74","252":"9aa8ef0f","304":"78bc16ed","403":"154bb940","423":"ce62e015","453":"b5e53887","951":"733bccf5","963":"01bd3ded"}[chunkId] + ".chunk.js";
};